import { PrintSettingsCacheValue, PrintSettingsFormValues } from "../types";
import { PAPER_SIZE } from "../../../common/enums";
import { PRINT_METHODS } from "../../../common/constants";
import { DownloadFileTypes } from "@reedexpo/mercury-badge";

const save = (settingsValues: PrintSettingsFormValues, printFormat: string, printMethod: string) => {
  const settingsToSave = { settingsValues, printFormat, printMethod };
  localStorage.setItem("printSettings", JSON.stringify(settingsToSave));
};

const get = () => {
  try {
    const cached = localStorage.getItem("printSettings");
    if (!cached) {
      throw Error();
    }
    return JSON.parse(cached) as PrintSettingsCacheValue;
  } catch (e) {
    return { printFormat: PAPER_SIZE.LETTER, printMethod: PRINT_METHODS[0]!.key, settingsValues: getDefaultValues() };
  }
};

const getDefaultValues = () => {
  return {
    selectedPrinter: "",
    printFileFormat: DownloadFileTypes.PDF,
    serverIP: "",
    serverPort: ""
  };
};

const PrintSettingsCache = {
  get,
  save,
  getDefaultValues
};

export default PrintSettingsCache;
